import {quotaMethods, quotaComputed} from "@/state/helpers";

export default {
    computed: {
        ...quotaComputed,
        quota() {
            return this.subscriptionQuota ? this.subscriptionQuota[this.quotaType] : {}
        },
        total() {
            return this.quota?.used + this.quota?.remaining
        },
        used() {
            return this.quota?.used
        },
        disabledQuota() {
            return this.total === this.quota?.used
        }
    },
    methods: {
        ...quotaMethods
    },
    created() {
        if (!this.noNeedQuota) {
            this.getSubscriptionQuota()
        }
    }
}
